import { initDataLayer, isBrowser } from '../util';
export function pushFilterExpanded(group, expanded) {
    initDataLayer();
    if (!isBrowser)
        return;
    window.dataLayer.push({
        event: 'filterExpandCollapseInteraction',
        filterExpanded: { filterName: group, expanded },
    });
}
